import Sg_Utils from './../../sg_utils/sg_utils';

window.skunkbaseConfig = window.skunkbaseConfig || {};
window.skunkbase = window.skunkbase || {};
skunkbase = (function () {
    'use strict';

    function getConfig() {
        var defaultConfig = {
            stats_url: '/stats/',
        };

        return Object.assign(defaultConfig, skunkbaseConfig);
    }

    function initUserInterface() {
        // GLOBAL VARS
        var body = document.body;

        // MOBILE MENU
        var toggle_menu_header = document.querySelector('.header .toggle-menu--button');
        if (toggle_menu_header) {
            Sg_Utils.addListener(toggle_menu_header, 'click', function (e) {
                e.preventDefault();
                Sg_Utils.toggleClass(body, 'menu-open');
            });
        }

        // MOBILE FOOTER
        var toggle_menu_footer = document.querySelector('.footer .toggle-menu--button');
        if (toggle_menu_footer) {
            Sg_Utils.addListener(toggle_menu_footer, 'click', function (e) {
                e.preventDefault();

                window.setTimeout(function () {
                    window.scrollTo(0, body.scrollHeight);
                }, 0);

                Sg_Utils.toggleClass(body, 'footer-open');
            });
        }

        // DESKTOP SEARCH
        var search_input = document.querySelector('.search-desktop--input');

        if (search_input) {
            // se o input tiver texto, não se fecha, para que o user possa ver o que escreveu
            Sg_Utils.addListener(search_input, 'keyup', function () {
                if (search_input.value.length > 0) {
                    Sg_Utils.addClass(search_input, 'is-active');
                } else {
                    Sg_Utils.removeClass(search_input, 'is-active');
                }
            });
        }

        // SEARCH ORDER OPTION
        var order_option = document.getElementById('order');
        if (order_option) {
            order_option.onchange = function () {
                location.href = Sg_Utils.urlAddParam(
                    location.href,
                    'o',
                    this.options[this.selectedIndex].value
                );
            };
        }

        // Sticky Ads
        if (typeof Sticky !== 'undefined') {
            new Sticky('.gpt-category-sidebar-sticky');
        }
    }

    function fetchBHoF() {
        Sg_Utils.getScript(
            (location.hostname.indexOf('.test') === -1 ? 'https://7gra.us' : '//resources.test') +
                '/bhof.js'
        );
    }

    return {
        init: function () {
            initUserInterface();
            fetchBHoF();
        },

        articlehit: function () {
            var config = getConfig(),
                article = document.getElementById('js-article');

            if (!article) {
                return;
            }

            var articleId = parseInt(article.getAttribute('data-art-id'));

            if (isNaN(articleId)) {
                return;
            }

            Sg_Utils.request(config.stats_url, 'POST', {
                type: 'article_hit',
                id: articleId,
            });
        },

        newshit: function () {
            var config = getConfig(),
                news = document.getElementById('js-news');

            if (!news) {
                return;
            }

            var newsId = parseInt(news.getAttribute('data-news-id'));

            if (isNaN(newsId)) {
                return;
            }

            Sg_Utils.request(config.stats_url, 'POST', {
                type: 'news_hit',
                id: newsId,
            });
        },

        categoryhit: function () {
            var config = getConfig(),
                category = document.getElementById('js-category');

            if (!category) {
                return;
            }

            var categoryId = parseInt(category.getAttribute('data-cat-id'));

            if (isNaN(categoryId)) {
                return;
            }

            Sg_Utils.request(config.stats_url, 'POST', {
                type: 'category_hit',
                id: categoryId,
            });
        },

        articleTable: function () {
            var elements = document.getElementsByTagName('table');
            if (elements) {
                var i;
                for (i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    var numberPattern = /\d+/g;

                    var compStylesParent = window.getComputedStyle(el.parentElement);
                    var spacingParentLeft =
                        +compStylesParent.getPropertyValue('padding-left').match(numberPattern) +
                        +compStylesParent.getPropertyValue('margin-left').match(numberPattern);

                    var spacingParentRight =
                        +compStylesParent.getPropertyValue('margin-right').match(numberPattern) +
                        +compStylesParent.getPropertyValue('padding-right').match(numberPattern);

                    if (
                        el.offsetWidth + spacingParentLeft + spacingParentRight >
                        el.parentElement.offsetWidth
                    ) {
                        var html =
                            '<div class="table-responsive" style="margin-right:-' +
                            spacingParentRight +
                            'px"><div class="table-shadow"></div><div class="table-wrapper">' +
                            el.outerHTML +
                            '</div></div>';
                        el.insertAdjacentHTML('afterend', html);
                        el.parentNode.removeChild(el);
                    } else {
                        Sg_Utils.addClass(el, 'table-normal');
                    }
                }
            }
        },
        userInterface: function () {
            initUserInterface();
        },
    };
})();
window.skunkbase = skunkbase;

export default skunkbase;

